import config from "console_config";
import { isInternalUser } from "Reducers/app/utils";

import {
  storePendoSession,
  hasPendoSession,
  initializePendoFromSession
} from "./pendoSessionStorage";

// https://support.pendo.io/hc/en-us/articles/360032294291-Configure-Track-Events
export const trackEventPendo = (name: string, event: Record<string, any>) => {
  if ((!config.ID_PENDO && !config.ID_PENDO_AUTH) || !window.pendo) return;
  window.pendo.track(name, event);
};

// Pendo: identify user
// identify user: https://support.pendo.io/hc/en-us/articles/6838229211675-Conditionally-initialize-Pendo
// data mapping: https://support.pendo.io/hc/en-us/articles/360038273392-Data-mapping-and-data-types-in-Pendo
// validate & debug: pendo.validateEnvironment() / pendo.enableDebugging()
export const identifyPendo = (
  user: Partial<{
    id: string;
    createdAt: string;
    email: string;
  }>
) => {
  const { id, createdAt, email } = user;

  if ((!config.ID_PENDO && !config.ID_PENDO_AUTH) || !window.pendo) return;

  // Check if we already have a valid session
  if (hasPendoSession() && Object.keys(user).length === 0) {
    // Try to initialize from existing session
    if (initializePendoFromSession()) {
      return;
    }
  }

  // Store session data for cross-application sharing
  if (Object.keys(user).length > 0) {
    storePendoSession({ id, createdAt, email });
  }

  window.pendo.initialize(
    Object.keys(user).length
      ? {
          visitor: {
            /* Reserved properties */
            id,
            created_at: createdAt,

            /* Custom Properties */
            roles: [
              isInternalUser(email) ? "is_platformer" : "is_normal_account"
            ]
          },

          // As per task FRONT-1436, this is a workaround for a bug on pendo side.
          location: {
            transforms: [
              {
                attr: "pathname",
                action: "Replace",
                data: function (pathname) {
                  const caseInsensitiveForwardSlash = /%2f/gi; // Detect %2F and %2f in URLS
                  const replaceWith = "--"; // Instruct Pendo to treat the %2f as "--"
                  return pathname.replace(
                    caseInsensitiveForwardSlash,
                    replaceWith
                  );
                }
              }
            ]
          }
        }
      : {}
  );
};

export const setPendoAccountInfo = ({
  accountId,
  type,
  agencyPartnerTier
}: {
  accountId: string | null;
  type?: string;
  agencyPartnerTier?: string;
}) => {
  if ((!config.ID_PENDO && !config.ID_PENDO_AUTH) || !window.pendo) return;

  window.pendo?.set_account_id?.(accountId);

  if (type) {
    window.pendo?.updateOptions({
      account: { type, agencyPartnerTier }
    });
  }
};
